import React from 'react'

import {CSSTransition, TransitionGroup} from 'react-transition-group'

import './_toast-layout.scss'

import cn from '../../libs/class-names'
import {mapChildrenWithFragments} from '../../services/react-children'

import {CommonProps, Overwrite} from '../../types'

interface ToastLayoutToastProps {
  toast: React.ReactElement
}

const ToastLayoutToast = ({toast, ...transitionProps}: ToastLayoutToastProps) => {
  const nodeRef = React.useRef<HTMLDivElement>(null)

  return (
    <CSSTransition
      {...transitionProps}
      nodeRef={nodeRef}
      classNames="ToastLayout__toast"
      onEntering={() => {
        if (nodeRef.current) {
          nodeRef.current.style.height = 'auto'
          const {height} = nodeRef.current.getBoundingClientRect()
          nodeRef.current.style.height = '0'
          // Trigger reflow
          nodeRef.current.scrollTop // eslint-disable-line @typescript-eslint/no-unused-expressions
          nodeRef.current.style.height = `${height}px`
        }
      }}
      onEntered={() => {
        if (nodeRef.current) {
          nodeRef.current.style.height = 'auto'
        }
      }}
      onExiting={() => {
        if (nodeRef.current) {
          const {height} = nodeRef.current.getBoundingClientRect()
          nodeRef.current.style.height = `${height}px`
          // Trigger reflow
          nodeRef.current.scrollTop // eslint-disable-line @typescript-eslint/no-unused-expressions
          nodeRef.current.style.height = '0'
        }
      }}
      addEndListener={done => {
        if (nodeRef.current) {
          nodeRef.current.addEventListener('transitioncancel', done, false)
          nodeRef.current.addEventListener('transitionend', done, false)
        }
      }}
    >
      <div className="ToastLayout__toast" ref={nodeRef}>
        {toast}
      </div>
    </CSSTransition>
  )
}

type Props = Overwrite<
  CommonProps<'div'>,
  {
    children: React.ReactNode
  }
>

const ToastLayout = ({className, children, ...props}: Props) => (
  <div {...props} className={cn('ToastLayout', {}, className)}>
    <TransitionGroup component={null}>
      {mapChildrenWithFragments(children, toast => (
        <ToastLayoutToast key={toast.key} toast={toast} />
      ))}
    </TransitionGroup>
  </div>
)

export default ToastLayout
